import angular from 'angular'
import './awards.service'
import './edit/edit.controller'

angular
  .module('admin.awards', ['admin.awards.service', 'admin.awards.edit'])
  .controller('AwardsCtrl', AwardsCtrl)

/** @ngInject */
function AwardsCtrl($state, $timeout, AwardsService) {
  var vm = this
  vm.model = {}
  vm.items = []
  vm.itemsPublished = []
  vm.itemsArchived = []

  var tab = localStorage.getItem('tabaward')
  if (tab !== null) {
    if (tab === 'manage') {
      $('#batch').removeClass('active')
      $('#managePublished').removeClass('active')
      $('#manageArchived').removeClass('active')
      $('#manage').addClass('active')
      $('#manageawarddraft').addClass('active')
    } else if (tab === 'managePublished') {
      $('#manage').removeClass('active')
      $('#batch').removeClass('active')
      $('#manageArchived').removeClass('active')
      $('#managePublished').addClass('active')
      $('#manageawardpublished').addClass('active')
    } else if (tab === 'manageArchived') {
      $('#manage').removeClass('active')
      $('#managePublished').removeClass('active')
      $('#batch').removeClass('active')
      $('#manageArchived').addClass('active')
      $('#manageawardarchived').addClass('active')
    } else {
      $('#manage').removeClass('active')
      $('#managePublished').removeClass('active')
      $('#manageArchived').removeClass('active')
      $('#batch').addClass('active')
      $('#batchaward').addClass('active')
    }
  } else {
    $('#manage').addClass('active')
    $('#manageawarddraft').addClass('active')
  }

  vm.tabManage = function() {
    $('#batch').removeClass('active')
    $('#managePublished').removeClass('active')
    $('#manageArchived').removeClass('active')
    $('#manage').addClass('active')
    localStorage.setItem('tabaward', 'manage')
  }

  vm.tabManagePublished = function() {
    $('#batch').removeClass('active')
    $('#manageArchived').removeClass('active')
    $('#manage').removeClass('active')
    $('#managePublished').addClass('active')
    localStorage.setItem('tabaward', 'managePublished')
  }

  vm.tabManageArchived = function() {
    $('#batch').removeClass('active')
    $('#managePublished').removeClass('active')
    $('#manage').removeClass('active')
    $('#manageArchived').addClass('active')
    localStorage.setItem('tabaward', 'manageArchived')
  }

  vm.tabBatch = function() {
    $('#managePublished').removeClass('active')
    $('#manage').removeClass('active')
    $('#manageArchived').removeClass('active')
    $('#batch').addClass('active')
    localStorage.setItem('tabaward', 'batch')
  }

  function reloadPagination() {
    vm.totalUsers = 0
    vm.oldPage = 0
    vm.perPage = 25
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function reloadPaginationPublished() {
    vm.totalUsers2 = 0
    vm.oldPage2 = 0
    vm.perPage2 = 25
    vm.currentPage2 = 25
    vm.first2 = true
    vm.totalItems2 = 0
    vm.pagination2 = {
      current: 1,
    }
  }

  function reloadPaginationArchived() {
    vm.totalUsers3 = 0
    vm.oldPage3 = 0
    vm.perPage3 = 25
    vm.currentPage3 = 25
    vm.first3 = true
    vm.totalItems3 = 0
    vm.pagination3 = {
      current: 1,
    }
  }

  reloadPagination()
  reloadPaginationPublished()
  reloadPaginationArchived()

  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    AwardsService.listDraft(vm.oldPage, 25).then(function(result) {
      var items = result.results
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }
      for (var i = 0; i < items.length; i++) {
        if (items[i].st) {
          if (items[i].st === 0) {
            items[i].status = 'Draft'
          } else if (items[i].st === 1) {
            items[i].status = 'Published'
          } else if (items[i].st === 2) {
            items[i].status = 'Archived'
          }
        }
        if (items[i]['ts-p'] !== undefined) {
          items[i]['ts-p'] = new Date(
            parseInt(
              items[i]['ts-p'].toString().substring(0, items[i]['ts-p'].toString().length - 3),
            ),
          )
        }
        if (items[i]['ts-x'] !== undefined) {
          items[i]['ts-x'] = new Date(
            parseInt(
              items[i]['ts-x'].toString().substring(0, items[i]['ts-x'].toString().length - 3),
            ),
          )
        }
      }

      vm.items = items
    })
  }

  function loadPublished(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination2.current = 1
    }
    if (!vm.first2) {
      vm.currentPage2 = pageNumber * 25
      vm.oldPage2 = vm.currentPage2 - 25
    } else {
      vm.first2 = false
    }

    AwardsService.listPublished(vm.oldPage2, 25).then(function(result) {
      var items = result.results
      if (vm.totalItems2 === 0) {
        vm.totalItems2 = result.ct
      }
      for (var i = 0; i < items.length; i++) {
        if (items[i].st) {
          if (items[i].st === 0) {
            items[i].status = 'Draft'
          } else if (items[i].st === 1) {
            items[i].status = 'Published'
          } else if (items[i].st === 2) {
            items[i].status = 'Archived'
          }
        }
        if (items[i]['ts-p'] !== undefined) {
          items[i]['ts-p'] = new Date(
            parseInt(
              items[i]['ts-p'].toString().substring(0, items[i]['ts-p'].toString().length - 3),
            ),
          )
        }
        if (items[i]['ts-x'] !== undefined) {
          items[i]['ts-x'] = new Date(
            parseInt(
              items[i]['ts-x'].toString().substring(0, items[i]['ts-x'].toString().length - 3),
            ),
          )
        }
      }

      vm.itemsPublished = items
    })
  }

  function loadArchived(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination3.current = 1
    }
    if (!vm.first3) {
      vm.currentPage3 = pageNumber * 25
      vm.oldPage3 = vm.currentPage3 - 25
    } else {
      vm.first3 = false
    }

    AwardsService.listUnpublished(vm.oldPage3, 25).then(function(result) {
      var items = result.results
      if (vm.totalItems3 === 0) {
        vm.totalItems3 = result.ct
      }
      for (var i = 0; i < items.length; i++) {
        if (items[i].st) {
          if (items[i].st === 0) {
            items[i].status = 'Draft'
          } else if (items[i].st === 1) {
            items[i].status = 'Published'
          } else if (items[i].st === 2) {
            items[i].status = 'Archived'
          }
        }
        if (items[i]['ts-p'] !== undefined) {
          items[i]['ts-p'] = new Date(
            parseInt(
              items[i]['ts-p'].toString().substring(0, items[i]['ts-p'].toString().length - 3),
            ),
          )
        }
        if (items[i]['ts-x'] !== undefined) {
          items[i]['ts-x'] = new Date(
            parseInt(
              items[i]['ts-x'].toString().substring(0, items[i]['ts-x'].toString().length - 3),
            ),
          )
        }
      }

      vm.itemsArchived = items
    })
  }

  load(1)
  loadPublished(1)
  loadArchived(1)

  vm.pageChanged = function(newPage) {
    load(newPage)
  }

  vm.add = function() {
    $state.go('admin.awards.edit', { id: 0 })
  }

  vm.edit = function(item) {
    $state.go('admin.awards.edit', { id: item.id })
  }

  vm.delete = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          AwardsService.remove(item.id).then(
            function() {
              $state.reload()
            },
            function(err) {
              $timeout(function() {
                swal(err.error.message, '', 'error')
              }, 200)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.publish = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          AwardsService.publish(item.id).then(
            function() {
              load(1)
              loadPublished(1)
              loadArchived(1)
            },
            function(err) {
              $timeout(function() {
                swal(err.error.message, '', 'error')
              }, 250)
            },
          )
        }
      },
    )
  }

  vm.unpublish = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          AwardsService.unpublish(item.id).then(
            function() {
              load(1)
              loadPublished(1)
              loadArchived(1)
            },
            function(err) {
              $timeout(function() {
                swal(err.error.message, '', 'error')
              }, 250)
            },
          )
        }
      },
    )
  }

  vm.creditTypes = [
    {
      id: 1,
      name: 'Primary Market',
    },
    {
      id: 2,
      name: 'Primary and Aftermarket',
    },
    {
      id: 3,
      name: 'Full Credit',
    },
  ]

  vm.save = function() {
    var model = angular.copy(vm.model)
    if (!model.amt || !model.k || !model.txt || !model.usernames) {
      swal('All fields is required!', '', 'error')
      return
    }

    model.usernames = model.usernames
      .split(' ')
      .join('')
      .split('\n')
      .map(function(item) {
        return item.trim()
      })
      .join(',')

    AwardsService.batch(model).then(function(result) {
      swal('Sent!', '', 'success')
      vm.model = {}
    })
  }

  vm.cancel = function() {
    $state.go('admin.home')
  }
}
